import Vue from "vue";
import Vuetify from "vuetify/lib/framework";
import "@mdi/font/css/materialdesignicons.css";

Vue.use(Vuetify);

const darkFromStorage = typeof localStorage !== "undefined" && localStorage.getItem("theme") === "dark";

export default new Vuetify({
  icons: {
    iconfont: "mdi",
  },
  theme: {
    dark: darkFromStorage,
    themes: {
      light: {
        primary: "#0293d3",
        secondary: "#1f2937",
      },
      dark: {
        primary: "#0293d3",
        secondary: "#1f2937",
      },
    },
  },
});
